module.exports = __webpack_public_path__ + "img/feature-atuacao-estadual.a902db43.svg";